/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Specifies how to handle secondary indices during restore. - `INDEX_RESTORE_MODE_KEEP`: Restore the indices as they were in the snapshot (default) - `INDEX_RESTORE_MODE_DISCARD`: Do not restore the indices 
*/
export enum IndexRestoreMode {
  INDEX_RESTORE_MODE_UNSPECIFIED = 'INDEX_RESTORE_MODE_UNSPECIFIED',
  INDEX_RESTORE_MODE_KEEP = 'INDEX_RESTORE_MODE_KEEP',
  INDEX_RESTORE_MODE_DISCARD = 'INDEX_RESTORE_MODE_DISCARD'
}
